<div class="flex flex-col gap-y-6 container-1-col">
  <div class="space-y-2">
    <h2 class="typo-h3">{{ 'doelen.doel-toevoegen-page.delen.title' | translate }}</h2>

    <p>{{ 'doelen.doel-toevoegen-page.delen.description' | translate }}</p>
  </div>

  <parkour-delen-section [delenFormGroup]="gedeeldMetSection" [teamleden]="teamleden" />
</div>
